export default {
  DOMES_MGMT_LIST_REQUEST: 'APP/DOMES_MGMT/DOMES_MGMT_LIST_REQUEST',
  DOMES_MGMT_LIST_SUCCESS: 'APP/DOMES_MGMT/DOMES_MGMT_LIST_SUCCESS',
  DOMES_MGMT_LIST_ERROR: 'APP/DOMES_MGMT/DOMES_MGMT_LIST_ERROR',
};
